const PaginationComponent = ({
    currentPage,
    totalPages,
    hasPreviousPage,
    hasNextPage,
    loading,
    onPageChange
}) => {
    // Fallback calculation if backend doesn't provide these values
    const canGoPrevious = hasPreviousPage ?? currentPage > 1;
    const canGoNext = hasNextPage ?? currentPage < totalPages;
    
    return (
        <div className="pagination">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={!canGoPrevious || loading}
                className="page-btn"
                aria-label="Previous page"
            >
                Previous
            </button>
            
            <div className="page-info">
                Page <span className="current-page">{currentPage}</span> of <span className="total-pages">{totalPages}</span>
            </div>
            
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={!canGoNext || loading}
                className="page-btn"
                aria-label="Next page"
            >
                Next
            </button>
        </div>
    );
};

export default PaginationComponent;